import React, { memo } from 'react';
import { ConfigProvider, theme as antdTheme } from 'antd';
import type { ThemeConfig } from 'antd/es/config-provider/context';

interface AntdThemeWrapperProps {
  children: React.ReactNode;
}

const lightTheme: ThemeConfig = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    colorPrimary: '#31347c',
    colorBgContainer: '#ffffff',
  },
  components: {
    Button: {
      colorPrimary: '#31347c',
      colorText: '#ffffff',
    },
  },
};

const ThemeWrapper: React.FC<AntdThemeWrapperProps> = ({ children }) => {
  return <ConfigProvider theme={lightTheme}>{children}</ConfigProvider>;
};

export default memo(ThemeWrapper);
